// extracted by mini-css-extract-plugin
module.exports = {"hr":"SidebarBox_hr__17SU8","box":"SidebarBox_box__3VH8S"};